<template>
  <div class="sns-share">
    <div class="share-text">
      <slot />
    </div>
    <div class="share-buttons">
      <button class="share-btn facebook" @click="facebookShare()">
        <img src="@images/sns-share/icon_facebook.png" />
      </button>
      <button class="share-btn twitter" @click="twitterShare()">
        <img src="@images/sns-share/icon_twitter.png" />
      </button>
      <button v-if="$route.params.lang === 'ja-JP'" class="share-btn line" @click="lineShare()">
        <img src="@images/sns-share/icon_line.png" />
      </button>
    </div>
  </div>
</template>

<script>
import localeCommon from '@locales/common'

export default {
  name: 'snsShare',
  $messages: localeCommon,
  props: {
    shareText: {
      type: String,
      default: null
    },
    replaceText: {
      type: Object,
      default: null
    }
  },
  computed: {
    gaAction() {
      let action = ''
      switch (this.$route.name) {
        case 'random':
          action = '_random'
          break
        case 'hero':
          action = '_cheer'
          break
        case 'voted':
          action = '_voted'
          break
        case 'results':
          action = '_result'
          break
        case 'results-detail':
          action = '_result'
          break
      }
      return action
    }
  },
  methods: {
    encodedUrl() {
      // MEMO: computedだと古いURLのままになってしまうので、shareボタンclick時のURLになるようにmethodsにした。
      const url = this.replaceText ? this.replaceText.url : location.href
      return encodeURIComponent(url)
    },
    facebookShare(){
      window.open(`https://www.facebook.com/sharer.php?u=${this.encodedUrl()}`, '_blank')
      this.sendGaEvent('share_facebook')
    },
    twitterShare(){
      let shareText = this.shareText ? this.$t(this.shareText, this.replaceText) : this.$t('footer.share.top', { url: location.href })
      shareText = shareText.replace(/<br>/g, '\n').replace(/&amp;/g, '&').replace(/&#039;/g, '\'')
      window.open(`http://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}`, '_blank')
      this.sendGaEvent('share_twitter')
    },
    lineShare(){
      let shareText = this.shareText ? this.$t(this.shareText, this.replaceText) : this.$t('footer.share.top', { url: location.href })
      shareText = shareText.replace(/<br>/g, '\n').replace(/&amp;/g, '&').replace(/&#039;/g, '\'')
      window.open(`http://line.me/R/msg/text/?${encodeURIComponent(shareText)}`, '_blank')
      this.sendGaEvent('share_line')
    },
    sendGaEvent(action){
      const sendPage = ['top', 'hero', 'voted', 'random', 'results', 'results-detail']
      if (sendPage.some(s => s === this.$route.name)) {
        this.$ga.event({
          eventCategory: 'click',
          eventAction: action + this.gaAction,
          eventLabel: 'ellection',
          eventValue: true
        })
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.sns-share {
  border-top: 1px solid #19272b;
  > .share-text {
    text-align: center;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  > .share-buttons {
    background-image: url(#{$img-path}sns-share/bg_share-buttons.png);
    background-repeat: repeat-x;
    background-position: 0 50%;
    height: 104px;
    display: flex;
    justify-content: center;
    > .share-btn {
      background-color: transparent;
      padding: 0;
      margin: 0 25px;
      @include tap-event();
      img {
        width: 100%;
      }
    }
  }
}
</style>
